import { motion } from 'framer-motion';
import { TrendingUp, Users, Award, Headphones } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const stats = [
  { icon: TrendingUp, value: '37+', key: 'stats_projects' },
  { icon: Users, value: '75+', key: 'stats_clients' },
  { icon: Award, value: '2+', key: 'stats_experience' },
  { icon: Headphones, value: '24/7', key: 'stats_support' },
];

export const StatsSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-8 sm:py-10 bg-[#1E3A5F]" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.key}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08 }}
              className="text-center flex flex-col items-center"
            >
              <div className="w-11 h-11 mb-3 rounded-xl bg-[#4A90D9]/20 flex items-center justify-center">
                <stat.icon size={22} className="text-[#4A90D9]" />
              </div>
              <p className="text-3xl font-bold text-white mb-1">{stat.value}</p>
              <p className="text-white/70 text-sm">{t(stat.key)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
